import { z } from 'zod'
import { ConversationStatus, SentimentLevel, ConversationRole, JourneyItemMediaPosition } from './enums'
import { Contact } from './contact'
import { FormJourneyItem } from './leadForm'
import { Media } from './media'

export const ConversationStep = z.object({
  id: z.string(),
  type: z.enum(['welcome', 'question', 'exit']),
  title: z.string(),
  caption: z.string().nullish(),
  media: Media.nullish(),
  mediaOpacitySetting: z.number().optional(),
  mediaPositionSetting: JourneyItemMediaPosition.optional(),
  children: z.any(),
})
export type ConversationStep = z.infer<typeof ConversationStep>

export const ConversationItem = z.object({
  role: ConversationRole,
  id: z.string(),
  content: z.string().nullish(),
  messageId: z.string().nullable(),
  files: z.array(z.string()).nullish(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  conversationId: z.string(),
  journeyItemId: z.string(),
  expense: z.number(),
})
export type ConversationItem = z.infer<typeof ConversationItem>

export const ConversationHiddenField = z.array(z.object({
  field: z.string(),
  value: z.string(),
}))
export type ConversationHiddenField = z.infer<typeof ConversationHiddenField>

export const Conversation = z.object({
  status: ConversationStatus,
  sentiment: SentimentLevel.nullable(),
  id: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  seen: z.boolean(),
  threadId: z.string(),
  referrer: z.string().nullable(),
  summary: z.string().nullable(),
  score: z.number().nullable(),
  customScore: z.number().nullable(),
  hiddenFields: ConversationHiddenField.nullish(),
  referral: z.string().nullable(),
  requiresGDPRConsent: z.boolean().nullable(),
  consent: z.boolean().nullable(),
  expense: z.number(),
  country: z.string().nullable(),
  contactId: z.string(),
  formId: z.string(),
  conversationItem: z.array(ConversationItem).nullish(),
  contact: Contact.nullish(),
  form: z.object({
    name: z.string(),
    journeyItems: z.array(FormJourneyItem),
  }).nullish(),
})
export type Conversation = z.infer<typeof Conversation>

export const ConversationSummaryItem = z.object({
  contact: Contact.pick({
    avatar: true,
    name: true,
    color: true,
  }),
  message: z.string(),
  createdAt: z.date(),
})
export type ConversationSummaryItem = z.infer<typeof ConversationSummaryItem>